export default __webpack_public_path__ + "static/bussinessSuccessbg-8a78ee10d67527efaec36e26646a65e8.png";